import { faFloppyDisk } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const SaveButton = ({ type = "button", buttonText = "Save", className, ...props }) => {
    return (
        <button
            type={type}
            className={`btn btn-primary d-flex align-items-center ${className || ''}`}
            {...props}
        >
            <FontAwesomeIcon icon={faFloppyDisk} className="me-1" />
            {buttonText}
        </button>
    )
}

export default SaveButton